import { Notification } from 'element-ui'
import store from '../store'
import router from '../router'
import md5 from 'md5'
import sha256 from 'sha256'
import http from 'http'
const zh = {
  prompt: '错误',
  noPermiss: '无权限, 请联系管理员',
  exist: '已存在',
  serverError: '服务器错误',
  tryAgain: '服务器忙！请稍后重试',
  connectionError: '网络连接错误'
}

const en = {
  prompt: 'error',
  noPermiss: 'No permission, please contact the administrator',
  exist: 'Already exist',
  serverError: 'Server error',
  tryAgain: 'Server busy! Please try again later',
  connectionError: 'Network connection error'
}

const notifyError = (message) => {
  let lang = localStorage.getItem('locale') === 'zh' ? zh : en
  return Notification({
    title: lang.prompt,
    message: message,
    duration: 4000,
    type: 'error'
  })
}

// 请求
export const reqSuccess = (config) => {
  const token = store.getters.userToken()
  const sensorToken = localStorage.getItem('sensorToken')
  let timestamp = Date.now()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
    config.headers['serviceCode'] = `solariot-a`
    config.headers['server-manage-token'] = `Bearer ${sensorToken}`
    config.headers['timestamp'] = timestamp
    config.headers['sign'] = md5(sha256(`solariot-a${timestamp}GBJr7xt3nEDAMlrb`))
    config.headers.common['Accept-language'] = localStorage.getItem('locale') === 'en' ? 'en-US' : 'zh-CN'
  }

  return config
}

export const reqError = (error) => {
  return Promise.reject(error)
}

// 响应
export const resSuccess = (res) => {
  return res
}

export const resError = (error) => {
  let lang = localStorage.getItem('locale') === 'zh' ? zh : en
  const res = error.response
  if (res) {
    switch (res.status) {
      case 400: // 客户端引起的异常
        if (res.config.url.indexOf('get-mote-with-relational-chain-info') !== -1) {
          return
        } else {
          notifyError(res.data.message || res.data.msg)
          break
        }
      case 401: // 没有携带有效的身份验证
        if(process.env.NODE_ENV == 'development'){
          return;
        }else{
          store.dispatch('logout')
          const currentRoute = router.currentRoute
          router.replace({ name: 'login', query: { redirect: currentRoute.name } })
        }
        break
      case 4000:
        http.v1Api.serverManageOauthNoTokenLogin()
        break
      case 403:
        notifyError(lang.noPermiss)
        break
      case 409: // 唯一性验证冲突
        notifyError(lang.exist)
        break
      case 422: // 请求参数字段验证不通过
        notifyError(res.data.message)
        break
      case 500: // 服务器内部错误
        notifyError(lang.serverError)
        break
      case 502:
        notifyError(lang.tryAgain)
        break
    }
  } else {
    // notifyError(error.message)
    notifyError(lang.connectionError)
  }
  return Promise.reject(error)
}
